(() => {
  if (window.g24CartOffersInitialized) return;
  window.g24CartOffersInitialized = true;
  const loadRecommendations = (slot) => {
    if (slot.dataset.loading === 'true' || slot.dataset.loaded === 'true') return;
    const productIds = (slot.dataset.productIds || '').split('|').filter(Boolean);
    if (!productIds.length) return;
    const sourceIds = slot.dataset.productIds;
    slot.dataset.loading = 'true';
    Promise.all(productIds.map((productId) => {
      const url = new URL(slot.dataset.url, window.location.href);
      url.searchParams.set('section_id', 'green24-cart-recommendations');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set('intent', 'related');
      return fetch(url, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.text() : '')
        .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-g24-cart-related]'))
        .catch(() => null);
    }))
      .then((sections) => {
        if (!slot.isConnected || slot.dataset.productIds !== sourceIds) return;
        const validSections = sections.filter(Boolean);
        if (!validSections.length) return;
        const inCart = new Set((slot.dataset.cartProductIds || '').split('|'));
        const seen = new Set();
        const groups = validSections.map((section) => [...section.querySelectorAll('[data-product-id]')]);
        const selected = [];
        let position = 0;
        while (selected.length < 4 && groups.some((group) => group.length > position)) {
          for (const group of groups) {
            const card = group[position];
            if (!card || inCart.has(card.dataset.productId) || seen.has(card.dataset.productId)) continue;
            selected.push(card);
            seen.add(card.dataset.productId);
            if (selected.length === 4) break;
          }
          position += 1;
        }
        if (!selected.length) return;
        const related = validSections[0];
        const rail = related.querySelector('ul');
        const heading = related.querySelector('h2');
        rail.replaceChildren(...selected);
        heading.id += slot.closest('.g24-cart-offers--drawer') ? '-drawer' : '-cart';
        related.setAttribute('aria-labelledby', heading.id);
        rail.tabIndex = 0;
        rail.setAttribute('role', 'region');
        rail.setAttribute('aria-label', heading.textContent.trim());
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * rail.clientWidth * .75, behavior: 'smooth' });
        });
        slot.replaceChildren(related);
      })
      .catch(() => {})
      .finally(() => {
        if (slot.isConnected) {
          slot.dataset.loading = 'false';
          slot.dataset.loaded = 'true';
        }
      });
  };

  const refresh = () => {
    document.querySelectorAll('[data-g24-cart-recommendations]').forEach(loadRecommendations);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  const observer = new MutationObserver(refresh);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-g24-pdf-form]')) return;
    event.preventDefault();
    const drawer = form.closest('cart-drawer');
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('.g24-cart-offers__error');
    if (!drawer || !button || button.disabled) return;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const body = new FormData(form);
      body.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = body;
      const response = await fetch(form.action, config);
      const result = await response.json();
      if (!response.ok || result.status || !result.sections?.['cart-drawer']) throw new Error(result.description || form.dataset.g24Error);
      drawer.renderContents(result);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'g24-cart-offers', cartData: result, variantId: body.get('id') });
    } catch (cause) {
      error.textContent = cause.message || form.dataset.g24Error;
      error.hidden = false;
    } finally {
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
})();

